import { generatePath as baseGeneratePath } from 'react-router-dom';
import { hasValue } from '@famly/stat_ts-utils_has-value';
import { buildUrlWithQueryParameters } from '@famly/vet_ts-utils_url';
import { extractParams } from './extract-params';
/**
 * Function that accepts a parametric path and its parameters, and returns the computed path
 * prefixed with a hash
 *
 * @param args [Path: string, Params?: object]
 * @returns `string` hashed path
 * @example
 * ```ts
 * generateHash('foo/:bar/wiz/:biz, {bar: 'a', biz: 'b'}); // "#/foo/a/wiz/b"
 * ```
 */
export const generatePath = (args) => {
    const [path, params, queryParams] = extractParams(args);
    const hash = baseGeneratePath(path, params);
    if (hasValue(queryParams)) {
        return buildUrlWithQueryParameters(hash, queryParams);
    }
    return hash;
};
